'use client';

import { usePathname } from 'next/navigation';

import Footer from './Footer';

const ConditionalFooter = () => {
  const pathname = usePathname();

  // authパスの場合はフッターを表示しない
  if (pathname.startsWith('/auth')) {
    return null;
  }

  // 配信閲覧ページでは画面サイズにかかわらずフッターを表示しない
  if (pathname === '/live' || pathname.startsWith('/live/')) {
    return null;
  }

  return <Footer />;
};

export default ConditionalFooter;
